var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "daisy-spinner spinner",
    style: {
      width: _vm.width,
      height: _vm.width
    }
  }, _vm._l(12, function (index) {
    return _c('div', {
      key: index,
      staticClass: "part",
      style: {
        transform: 'rotate(' + 30 * index + 'deg)',
        'animation-delay': -index * 0.1 + 's',
        width: _vm.indicatorWidth
      }
    }, [_c('div', {
      staticClass: "indicator",
      style: {
        transform: 'translate(' + _vm.indicatorX + ', 0px)'
      }
    })]);
  }), 0);
};
var staticRenderFns = [];
export { render, staticRenderFns };